import { render, staticRenderFns } from "./LoginOauth.vue?vue&type=template&id=b2be5440"
import script from "./LoginOauth.vue?vue&type=script&lang=js"
export * from "./LoginOauth.vue?vue&type=script&lang=js"
import style0 from "./LoginOauth.vue?vue&type=style&index=0&id=b2be5440&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports